import * as messageService from "../../services/message.service";
import * as formDownloadService from '../../services/formDownload.service';


const state = {
    formDownloadAll:[],
    formDownloadAllActive:[],
};

const getters = {
    gettFormDownloadAll:state => (state.formDownloadAll),
    gettFormDownloadAllActive:state => (state.formDownloadAllActive),
};

const actions = {
    async fetchFormDownloadAll({ commit } ){
        try {
            const response = await formDownloadService.all();
            commit('setFormDownloadAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchFormDownloadAllActive({ commit } ){
        try {
            const response = await formDownloadService.allActive();
            commit('setFormDownloadAllActive', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
};

const mutations = {
    setFormDownloadAll:(state, res) => (
        state.formDownloadAll =  res
    ),
    setFormDownloadAllActive:(state, res) => (
        state.formDownloadAllActive =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}